import {
  CACHED_LOCATIONS,
  CACHED_ROUTE_CONFIG,
  LOCATION_RESTRICTED_CACHED_ROUTE_CONFIG,
} from "./config";

const CACHE_PROXY_ENABLED =
  import.meta.env.REACT_APP_ENABLE_API_CACHE_PROXY === "true";

function isCachedLocation() {
  const href = window?.location?.href?.toLowerCase() || "";
  return CACHED_LOCATIONS.some((code) => href.includes(code.toLowerCase()));
}

function matchRoute(url, routeConfig) {
  // Exact match
  let ttlMs = routeConfig[url];

  // Prefix match: keys ending with * are treated as URL prefixes
  if (!ttlMs) {
    for (const [key, ttl] of Object.entries(routeConfig)) {
      if (key.endsWith("*") && url.startsWith(key.slice(0, -1))) {
        ttlMs = ttl;
        break;
      }
    }
  }

  return ttlMs;
}

export function rewriteForCache(url) {
  if (!CACHE_PROXY_ENABLED || !url) return { url, ttlMs: 0 };

  // SEO pages are cached for all locations.
  let ttlMs = matchRoute(url, CACHED_ROUTE_CONFIG);

  // Other cacheable APIs are restricted to a set of test locations for now.
  if (!ttlMs && isCachedLocation()) {
    ttlMs = matchRoute(url, LOCATION_RESTRICTED_CACHED_ROUTE_CONFIG);
  }

  if (!ttlMs) return { url, ttlMs: 0 };

  try {
    const parsed = new URL(url);
    return {
      url: `/api-cache${parsed.pathname}${parsed.search}`,
      ttlMs,
    };
  } catch {
    return { url, ttlMs: 0 };
  }
}
